import React from "react";

interface PackageExpiryNoticeProps {
  packageType: "monthly" | "yearly";
  createdDate: string;
}

const PackageExpiryNotice: React.FC<PackageExpiryNoticeProps> = ({
  packageType,
  createdDate,
}) => {
  const created = new Date(createdDate);
  const expiry = new Date(created);

  // Calculate expiry date
  if (packageType === "monthly") {
    expiry.setMonth(expiry.getMonth() + 1);
  } else if (packageType === "yearly") {
    expiry.setFullYear(expiry.getFullYear() + 1);
  }

  const today = new Date();
  const diffInMs = expiry.getTime() - today.getTime();
  const daysLeft = Math.ceil(diffInMs / (1000 * 60 * 60 * 24));
  const expiryFormatted = expiry.toISOString().split("T")[0];

  return (
    <div>
      {daysLeft <= 10 && daysLeft >= 0 && (
        <div className="alert alert-danger" role="alert">
           Your package will expire on <strong>{expiryFormatted}</strong> (
          in {daysLeft} day{daysLeft !== 1 ? "s" : ""})
        </div>
      )}

      {daysLeft < 0 && (
        <div className="alert alert-danger" role="alert">
           Your package expired on <strong>{expiryFormatted}</strong>
        </div>
      )}
    </div>
  );
};

export default PackageExpiryNotice;
